import React from 'react';
import { useReactFlow } from '@xyflow/react';
import { LayoutGrid, Plus, Minus, Maximize2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface CanvasControlsProps {
  onAutoLayout: () => void;
}

/**
 * 统一的画布控制组件
 * 完全自定义实现，整合了缩放控制、适应视图和自动布局功能
 */
const CanvasControls: React.FC<CanvasControlsProps> = ({ onAutoLayout }) => {
  const { zoomIn, zoomOut, fitView } = useReactFlow();
  const { t } = useTranslation();

  const handleFitView = () => {
    fitView({ padding: 0.2, duration: 300 });
  };

  return (
    <div className="bg-slate-800 border border-slate-700 rounded-lg p-1 flex flex-col gap-2">
      {/* 放大按钮 */}
      <button
        onClick={() => zoomIn({ duration: 300 })}
        className="hover:bg-slate-700 transition-colors rounded"
        title={t('canvas.controls.zoomIn')}
        style={{
          width: '22px',
          height: '22px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Plus size={14} className="text-slate-300" strokeWidth={2.5} />
      </button>

      {/* 缩小按钮 */}
      <button
        onClick={() => zoomOut({ duration: 300 })}
        className="hover:bg-slate-700 transition-colors rounded"
        title={t('canvas.controls.zoomOut')}
        style={{
          width: '22px',
          height: '22px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Minus size={14} className="text-slate-300" strokeWidth={2.5} />
      </button>

      {/* 适应视图按钮 */}
      <button
        onClick={handleFitView}
        className="hover:bg-slate-700 transition-colors rounded"
        title={t('canvas.controls.fitView')}
        style={{
          width: '22px',
          height: '22px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Maximize2 size={14} className="text-slate-300" strokeWidth={2} />
      </button>

      {/* 自动布局按钮 */}
      <button
        onClick={onAutoLayout}
        className="hover:bg-slate-700 transition-colors rounded"
        title={t('canvas.controls.autoLayout')}
        style={{
          width: '22px',
          height: '22px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <LayoutGrid size={14} className="text-slate-300" strokeWidth={1.5} />
      </button>
    </div>
  );
};

export default CanvasControls;
